import loadable from '@loadable/component'
import { Route, Switch } from 'react-router'

import { AppInitialProps } from './@types'

const Admin = loadable(() => import('./components/Admin'), {
  resolveComponent: components => components.Admin,
})

const SlateApp = loadable(() => import('./SlateApp'), {
  resolveComponent: module => module.SlateApp,
})

const PostEmbed = loadable(() => import('./embed/Post'), {
  resolveComponent: module => module.PostEmbed,
})

const SpaceEmbed = loadable(() => import('./embed/Space'), {
  resolveComponent: module => module.SpaceEmbed,
})

const Unsubscribe = loadable(
  () => import('./components/Settings/Unsubscribe'),
  {
    resolveComponent: module => module.Unsubscribe,
  },
)

export const Routes = ({ pageProps }: { pageProps: AppInitialProps }) => (
  <Switch>
    <Route path="/admin">
      <Admin />
    </Route>
    <Route path="/manage">
      <Admin />
    </Route>
    <Route exact path="/embed/post/:id">
      <PostEmbed />
    </Route>
    <Route exact path="/embed/space/:slug">
      <SpaceEmbed />
    </Route>
    <Route path="/settings/notifications/unsubscribe" exact>
      <Unsubscribe />
    </Route>
    <Route>
      <SlateApp pageProps={pageProps} />
    </Route>
  </Switch>
)
